export default __webpack_public_path__ + "static/media/NoeDisplay-Medium.fb87ef82.eot";